// https://github.com/dhenderson/ntee/blob/master/ntee.json
export const NTEE: string[] = [
  ...new Set([
    'Arts, Culture & Humanities',
    'Alliances & Advocacy',
    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Arts & Culture',

    'Cultural & Ethnic Awareness',

    'Folk Arts',

    'Arts Education',

    'Arts & Humanities Councils & Agencies',

    'Community Celebrations',

    'Media & Communications',

    'Film & Video',

    'Television',

    'Printing & Publishing',

    'Radio',

    'Visual Arts',

    'Museums',

    'Art Museums',

    "Children's Museums",

    'Folk Arts Museums',

    'History Museums',

    'Natural History & Natural Science Museums',

    'Science & Technology Museums',

    'Performing Arts',

    'Performing Arts Centers',

    'Dance',

    'Ballet',

    'Theater',

    'Music',

    'Symphony Orchestras',

    'Opera',

    'Singing & Choral Groups',

    'Bands & Ensembles',

    'Performing Arts Schools',

    'Humanities',

    'Historical Organizations',

    'Historical Societies & Historic Preservation',

    'Commemorative Events',

    'Arts Services',

    'Arts, Culture & Humanities N.E.C.',

    'Education',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Elementary & Secondary Schools',

    'Preschools',

    'Primary & Elementary Schools',

    'Secondary & High Schools',

    'Special Education',

    'Charter Schools',

    'Vocational & Technical Schools',

    'Higher Education',

    'Two-Year Colleges',

    'Undergraduate Colleges',

    'Universities',

    'Graduate & Professional Schools',

    'Adult Education',

    'Libraries',

    'Student Services',

    'Scholarships & Student Financial Aid',

    'Student Sororities & Fraternities',

    'Alumni Associations',

    'Educational Services',

    'Remedial Reading & Encouragement',

    'Parent & Teacher Groups',

    'Education N.E.C.',

    'Environment',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Pollution Abatement & Control',

    'Recycling',

    'Natural Resources Conservation & Protection',

    'Water Resources, Wetlands Conservation & Management',

    'Land Resources Conservation',

    'Energy Resources Conservation & Development',

    'Forest Conservation',

    'Botanical, Horticultural & Landscape Services',

    'Botanical Gardens & Arboreta',

    'Garden Clubs',

    'Environmental Beautification',

    'Environmental Education',

    'Environment N.E.C.',

    'Animal-Related',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Animal Protection & Welfare',

    'Wildlife Preservation & Protection',

    'Protection of Endangered Species',

    'Bird Sanctuaries',

    'Fisheries Resources',

    'Wildlife Sanctuaries',

    'Veterinary Services',

    'Zoos & Aquariums',

    'Animal Services N.E.C.',

    'Animal Training',

    'Animal-Related  N.E.C.',

    'Health Care',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Hospitals',

    'Community Health Systems',

    'General Hospitals',

    'Specialty Hospitals',

    'Ambulatory & Primary Health Care',

    'Group Health Practices',

    'Community Clinics',

    'Reproductive Health Care',

    'Family Planning',

    'Rehabilitative Care',

    'Health Support',

    'Blood Banks',

    'Emergency Medical Services & Transport',

    'Organ & Tissue Banks',

    'Public Health',

    'Health (General & Financing)',

    'Patient & Family Support',

    'Nursing',

    'Nursing Facilities',

    'Home Health Care',

    'Health Care N.E.C.',

    'Mental Health & Crisis Intervention',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Substance Abuse Dependency, Prevention & Treatment',

    'Substance Abuse Prevention',

    'Substance Abuse Treatment',

    'Mental Health Treatment',

    'Psychiatric Hospitals',

    'Community Mental Health Centers',

    'Residential Mental Health Treatment',

    'Hot Lines & Crisis Intervention',

    'Sexual Assault Services',

    'Addictive Disorders N.E.C.',

    'Smoking Addiction',

    'Eating Disorders & Addictions',

    'Gambling Addiction',

    'Counseling',

    'Mental Health Disorders',

    'Mental Health Associations',

    'Mental Health & Crisis Intervention N.E.C.',

    'Voluntary Health Associations & Medical Disciplines',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Birth Defects & Genetic Diseases',

    'Down Syndrome',

    'Cancer',

    'Breast Cancer',

    'Diseases of Specific Organs',

    'Eye Diseases, Blindness & Vision Impairments',

    'Ear & Throat Diseases',

    'Heart & Circulatory System Diseases & Disorders',

    'Kidney Diseases',

    'Lung Diseases',

    'Brain Disorders',

    'Nerve, Muscle & Bone Diseases',

    'Arthritis',

    'Epilepsy',

    'Allergy-Related Diseases',

    'Asthma',

    'Digestive Diseases & Disorders',

    'Specifically Named Diseases',

    'AIDS',

    'Alzheimers Disease',

    'Autism',

    'Medical Disciplines',

    'Biomedicine & Bioengineering',

    'Geriatrics',

    'Neurology & Neuroscience',

    'Pediatrics',

    'Voluntary Health Associations & Medical Disciplines N.E.C.',

    'Surgical Specialties',

    'Medical Research',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Birth Defects & Genetic Diseases Research',

    'Down Syndrome Research',

    'Cancer Research',

    'Breast Cancer Research',

    'Diseases of Specific Organs Research',

    'Eye Diseases, Blindness & Vision Impairments Research',

    'Ear & Throat Diseases Research',

    'Heart & Circulatory System Diseases & Disorders Research',

    'Kidney Diseases  Research',

    'Lung Diseases Research',

    'Brain Disorders Research',

    'Nerve, Muscle & Bone Diseases Research',

    'Arthritis Research',

    'Epilepsy Research',

    'Allergy-Related Diseases Research',

    'Asthma Research',

    'Digestive Diseases & Disorders Research',

    'Specifically Named Diseases Research',

    'AIDS Research',

    'Alzheimers Disease Research',

    'Autism Research',

    'Medical Disciplines Research',

    'Biomedicine & Bioengineering Research',

    'Geriatrics Research',

    'Neurology & Neuroscience Research',

    'Pediatrics Research',

    'Medical Research N.E.C.',

    'Surgical Specialties Research',

    'Crime & Legal-Related',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Crime Prevention',

    'Youth Violence Prevention',

    'Drunk Driving-Related',

    'Correctional Facilities',

    'Half-Way Houses for Offenders & Ex-Offenders',

    'Rehabilitation Services for Offenders',

    'Inmate Support',

    'Prison Alternatives',

    'Administration of Justice',

    'Dispute Resolution & Mediation',

    'Law Enforcement',

    'Protection Against Abuse',

    'Spouse Abuse Prevention',

    'Child Abuse Prevention',

    'Sexual Abuse Prevention',

    'Legal Services',

    'Public Interest Law',

    'Crime & Legal-Related N.E.C.',

    'Employment',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Employment Preparation & Procurement',

    'Vocational Counseling',

    'Job Training',

    'Vocational Rehabilitation',

    'Goodwill Industries',

    'Sheltered Employment',

    'Labor Unions',

    'Employment N.E.C.',

    'Food, Agriculture & Nutrition',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Agricultural Programs',

    'Farmland Preservation',

    'Animal Husbandry',

    'Farm Bureaus & Granges',

    'Food Programs',

    'Food Banks & Pantries',

    'Congregate Meals',

    'Soup Kitchens',

    'Meals on Wheels',

    'Nutrition',

    'Home Economics',

    'Food, Agriculture & Nutrition N.E.C.',

    'Housing & Shelter',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Housing Development, Construction & Management',

    'Low-Income & Subsidized Rental Housing',

    'Senior Citizens Housing & Retirement Communities',

    'Independent Housing for People with Disabilities',

    'Housing Rehabilitation',

    'Housing Search Assistance',

    'Temporary Housing',

    'Homeless Shelters',

    'Homeowners & Tenants Associations',

    'Housing Support',

    'Home Improvement & Repairs',

    'Housing Expense Reduction Support',

    'Housing & Shelter N.E.C.',

    'Public Safety, Disaster Preparedness & Relief',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Disaster Preparedness & Relief Services',

    'Search & Rescue Squads',

    'Fire Prevention',

    'Safety Education',

    'First Aid',

    'Automotive Safety',

    'Public Safety Benevolent Associations',

    'Public Safety, Disaster Preparedness & Relief N.E.C.',

    'Recreation & Sports',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Camps',

    'Physical Fitness & Community Recreational Facilities',

    'Community Recreational Centers',

    'Parks & Playgrounds',

    'Sports Associations & Training Facilities',

    'Recreational Clubs',

    'Fairs',

    'Amateur Sports',

    'Fishing & Hunting',

    'Basketball',

    'Baseball & Softball',

    'Soccer',

    'Football',

    'Racquet Sports',

    'Swimming & Other Water Recreation',

    'Winter Sports',

    'Equestrian',

    'Golf',

    'Amateur Sports Competitions',

    'Olympics',

    'Special Olympics',

    'Professional Athletic Leagues',

    'Recreation & Sports N.E.C.',

    'Youth Development',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Youth Centers & Clubs',

    'Boys Clubs',

    'Girls Clubs',

    'Boys & Girls Clubs',

    'Adult & Child Matching Programs',

    'Big Brothers & Big Sisters',

    'Scouting',

    'Boy Scouts of America',

    'Girl Scouts of the U.S.A.',

    'Camp Fire',

    'Youth Development Programs',

    'Youth Community Service Clubs',

    'Youth Development - Agricultural',

    'Youth Development - Business',

    'Youth Development - Citizenship',

    'Youth Development - Religious Leadership',

    'Youth Development N.E.C.',

    'Human Services',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Human Service Organizations',

    'American Red Cross',

    'Urban League',

    'Salvation Army',

    'Volunteers of America',

    'Young Mens or Womens Associations',

    'Neighborhood Centers',

    'Thrift Shops',

    'Children & Youth Services',

    'Adoption',

    'Foster Care',

    'Child Day Care',

    'Family Services',

    'Single Parent Agencies',

    'Family Violence Shelters',

    'In-Home Assistance',

    'Family Services for Adolescent Parents',

    'Family Counseling',

    'Pregnancy Centers',

    'Personal Social Services',

    'Financial Counseling',

    'Transportation Assistance',

    'Gift Distribution',

    'Emergency Assistance',

    'Travelers Aid',

    'Victims Services',

    'Residential Care & Adult Day Programs',

    'Adult Day Care',

    'Group Homes',

    'Hospices',

    'Supportive Housing for Older Adults',

    'Homes for Children & Adolescents',

    'Centers to Support the Independence of Specific Populations',

    'Senior Centers',

    'Developmentally Disabled Centers',

    "Women's Centers",

    'Ethnic &  Immigrant Centers',

    'Homeless Centers',

    'Blind & Visually Impaired Centers',

    'Deaf & Hearing Impaired Centers',

    'LGBT Centers',

    'Human Services N.E.C.',

    'International, Foreign Affairs & National Security',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Promotion of International Understanding',

    'International Cultural Exchange',

    'International Academic Exchange',

    'International Exchange N.E.C.',

    'International Development',

    'International Agricultural Development',

    'International Economic Development',

    'International Relief',

    'International Educational Development ',

    'International Democracy & Civil Society Development',

    'International Science & Technology Development ',

    'International Environment, Population & Sustainability ',

    'International Health Development ',

    'International Peace & Security',

    'Arms Control & Peace',

    'United Nations Associations',

    'National Security',

    'International Affairs, Foreign Policy, & Globalization',

    'International Economic & Trade Policy',

    'International Human Rights',

    'International Migration & Refugee Issues',

    'International, Foreign Affairs & National Security N.E.C.',

    'Civil Rights, Social Action & Advocacy',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Civil Rights',

    "Immigrants' Rights",

    'Minority Rights',

    'Disabled Persons Rights',

    'Womens Rights',

    'Seniors Rights',

    'Lesbian & Gay Rights',

    "Patients' Rights",

    "Children's Rights",

    "Employee & Workers' Rights",

    'Intergroup & Race Relations',

    'Voter Education & Registration',

    'Civil Liberties',

    'Reproductive Rights',

    'Right to Life',

    'Censorship, Freedom of Speech & Press',

    'Freedom of Religion Issues',

    'Right to Die & Euthanasia',

    'Civil Rights, Social Action & Advocacy N.E.C.',

    'Community Improvement & Capacity Building',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Community & Neighborhood Development',

    'Community Coalitions',

    'Neighborhood & Block Associations',

    'Economic Development',

    'Urban & Community Economic Development',

    'Rural Economic Development',

    'Business & Industry',

    'Chambers of Commerce & Business Leagues',

    'Small Business Development',

    'Boards of Trade',

    'Real Estate Associations',

    'Nonprofit Management',

    'Community Service Clubs',

    'Womens Service Clubs',

    'Mens Service Clubs',

    'Community Improvement & Capacity Building N.E.C.',

    'Philanthropy, Voluntarism & Grantmaking Foundations',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Private Grantmaking Foundations',

    'Corporate Foundations',

    'Private Independent Foundations',

    'Private Operating Foundations',

    'Public Foundations',

    'Community Foundations',

    'Voluntarism Promotion',

    'Philanthropy, Charity & Voluntarism Promotion',

    'Federated Giving Programs',

    'Named Trusts N.E.C.',

    'Philanthropy, Voluntarism & Grantmaking Foundations N.E.C.',

    'Science & Technology',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'General Science',

    'Marine Science & Oceanography',

    'Physical & Earth Sciences',

    'Astronomy',

    'Chemistry & Chemical Engineering',

    'Mathematics',

    'Geology',

    'Engineering & Technology',

    'Computer Science',

    'Engineering',

    'Biological & Life Sciences',

    'Science & Technology N.E.C.',

    'Social Science',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Social Science',

    'Anthropology & Sociology',

    'Economics',

    'Behavioral Science',

    'Political Science',

    'Population Studies',

    'Law & Jurisprudence',

    'Interdisciplinary Research',

    'Black Studies',

    'Womens Studies',

    'Ethnic Studies',

    'Urban Studies',

    'International Studies',

    'Gerontology',

    'Labor Studies',

    'Social Science N.E.C.',

    'Public & Societal Benefit',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Government & Public Administration',

    'Public Finance, Taxation & Monetary Policy',

    'Citizen Participation',

    'Military & Veterans Organizations',

    'Public Transportation Systems',

    'Telecommunications',

    'Financial Institutions',

    'Credit Unions',

    'Leadership Development',

    'Public Utilities',

    'Consumer Protection',

    'Public & Societal Benefit N.E.C.',

    'Religion-Related',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Christianity',

    'Protestant',

    'Roman Catholic',

    'Judaism',

    'Islam',

    'Buddhism',

    'Hinduism',

    'Religious Media & Communications',

    'Religious Film & Video',

    'Religious Television',

    'Religious Printing & Publishing',

    'Religious Radio',

    'Interfaith Coalitions',

    'Religion-Related N.E.C.',

    'Mutual & Membership Benefit',

    'Alliances & Advocacy',

    'Management & Technical Assistance',

    'Professional Societies & Associations',

    'Research Institutes & Public Policy Analysis',

    'Single Organization Support',

    'Fund Raising & Fund Distribution',

    'Support N.E.C.',

    'Insurance Providers',

    'Local Benevolent Life Insurance Associations',

    'Mutual Insurance Companies & Associations',

    'Supplemental Unemployment Compensation',

    'State-Sponsored Workers Compensation Reinsurance Organizations',

    'Pension & Retirement Funds',

    'Teachers Retirement Fund Associations',

    'Employee Funded Pension Trusts',

    'Multi-Employer Pension Plans',

    'Fraternal Societies',

    'Fraternal Beneficiary Societies',

    'Domestic Fraternal Societies',

    'Voluntary Employees Beneficiary Associations (Non-Government)',

    'Voluntary Employees Beneficiary Associations  Government)',

    'Cemeteries',

    'Mutual & Membership Benefit N.E.C.',
  ]),
]
